import React from "react";

export default function() {
  return (
    <div>
      <h1>We have not found what you are looking for, sorry...</h1>
    </div>
  );
}
